// // HomePage.js
// // இங்க invoice table இருக்கும்
// // Length x Height = Sqft auto calculate ஆகும்
// // + Add Row, Delete Row இருக்கும்
// // localStorage-ல save ஆகும் - page close ஆனாலும் data போகாது

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import logoImg from '../assets/logo.png'; // உங்க logo இங்க வையுங்க

// // ஒரு empty row template
// const emptyRow = () => ({
//   id: Date.now() + Math.random(),
//   description: '',
//   length: '',
//   height: '',
//   sqft: '',
//   rate: '',
//   total_rate: ''
// });

// function HomePage() {
//   const navigate = useNavigate();

//   // localStorage-லிருந்து data load பண்றோம் (page refresh safe)
//   const [rows, setRows] = useState(() => {
//     const saved = localStorage.getItem('invoice_rows');
//     if (saved) {
//       try { return JSON.parse(saved); }
//       catch { return [emptyRow()]; }
//     }
//     return [emptyRow()];
//   });

//   // Rows change ஆகும் போதெல்லாம் localStorage-ல save பண்றோம்
//   useEffect(() => {
//     localStorage.setItem('invoice_rows', JSON.stringify(rows));
//   }, [rows]);

//   // ஒரு cell value மாறும்போது
//   const handleChange = (id, field, value) => {
//     setRows(prev => prev.map(row => {
//       if (row.id !== id) return row;

//       const updated = { ...row, [field]: value };

//       // Length or Height மாறினா sqft auto calculate
//       const len = parseFloat(field === 'length' ? value : updated.length) || 0;
//       const hgt = parseFloat(field === 'height' ? value : updated.height) || 0;
      
//       // sqft = length x height (both > 0 இருந்தா மட்டும்)
//       if (len > 0 && hgt > 0) {
//         updated.sqft = (len * hgt).toFixed(2);
//       } else if (field === 'length' || field === 'height') {
//         // One of them is 0 or empty - qty as sqft
//         updated.sqft = len > 0 ? len.toFixed(2) : '';
//       }

//       // Rate மாறினாலும் / sqft மாறினாலும் total recalculate
//       const sqftVal = parseFloat(field === 'sqft' ? value : updated.sqft) || 0;
//       const rateVal = parseFloat(field === 'rate' ? value : updated.rate) || 0;
      
//       if (sqftVal > 0 && rateVal > 0) {
//         updated.total_rate = (sqftVal * rateVal).toFixed(2);
//       } else {
//         updated.total_rate = '';
//       }

//       return updated;
//     }));
//   };

//   // New row add பண்றோம்
//   const addRow = () => {
//     setRows(prev => [...prev, emptyRow()]);
//   };

//   // Row delete பண்றோம்
//   const deleteRow = (id) => {
//     if (rows.length === 1) {
//       alert('குறைந்தது ஒரு row இருக்கணும்!');
//       return;
//     }
//     setRows(prev => prev.filter(row => row.id !== id));
//   };

//   // Total calculate
//   const grandTotal = rows.reduce((sum, row) => {
//     return sum + (parseFloat(row.total_rate) || 0);
//   }, 0);

//   // Proceed to Checklist
//   const handleNext = () => {
//     const hasData = rows.some(r => r.description || r.total_rate);
//     if (!hasData) {
//       alert('குறைந்தது ஒரு item add பண்ணுங்க!');
//       return;
//     }
//     navigate('/checklist');
//   };

//   // Table clear பண்றோம்
//   const handleClear = () => {
//     if (window.confirm('எல்லா data-வும் clear பண்றீங்களா?')) {
//       localStorage.removeItem('invoice_rows');
//       setRows([emptyRow()]);
//     }
//   };

//   return (
//     <div>
//       {/* Header */}
//       <div className="header">
//         <div className="header-logo">
//           <img 
//             src={logoImg} 
//             alt="Akshaya Logo"
//             onError={(e) => { e.target.style.display='none'; }}
//           />
//           <div className="header-title">
//             <h1>AKSHAYA</h1>
//             <p>Wood Furniture & Interiors</p>
//           </div>
//         </div>
//         <div className="header-contact">
//           <p>GST: 33CGAPS5480A2ZN</p>
//           <p>📞 Cell: 9965113567</p>
//           <p>No 38/12, Digital Garden, Annanji, Theni - 625531</p>
//         </div>
//       </div>

//       <div className="container">
//         <div className="card">
//           <div className="section-title">📋 Invoice Items</div>

//           <div style={{ overflowX: 'auto' }}>
//             <table className="invoice-table">
//               <thead>
//                 <tr>
//                   <th style={{ width: '50px' }}>S.No</th>
//                   <th style={{ width: '250px' }}>Description</th>
//                   <th style={{ width: '90px' }}>Length</th>
//                   <th style={{ width: '90px' }}>Height</th>
//                   <th style={{ width: '100px' }}>Sqft / Qty / Feet</th>
//                   <th style={{ width: '100px' }}>Rate (₹)</th>
//                   <th style={{ width: '110px' }}>Total Rate (₹)</th>
//                   <th style={{ width: '70px' }}>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {rows.map((row, index) => (
//                   <tr key={row.id}>
//                     <td>{index + 1}</td>
//                     <td>
//                       <input
//                         type="text"
//                         placeholder="Product Name..."
//                         value={row.description}
//                         onChange={e => handleChange(row.id, 'description', e.target.value)}
//                         style={{ textAlign: 'left' }}
//                       />
//                     </td>
//                     <td>
//                       <input
//                         type="number"
//                         placeholder="0"
//                         value={row.length}
//                         onChange={e => handleChange(row.id, 'length', e.target.value)}
//                         min="0"
//                         step="0.01"
//                       />
//                     </td>
//                     <td>
//                       <input
//                         type="number"
//                         placeholder="0"
//                         value={row.height}
//                         onChange={e => handleChange(row.id, 'height', e.target.value)}
//                         min="0"
//                         step="0.01"
//                       />
//                     </td>
//                     <td className="sqft-cell">
//                       <input
//                         type="number"
//                         placeholder="auto"
//                         value={row.sqft}
//                         onChange={e => handleChange(row.id, 'sqft', e.target.value)}
//                         min="0"
//                         step="0.01"
//                         style={{ color: '#2e7d32', fontWeight: '600' }}
//                         title="Length x Height = Sqft (auto). Manual-ah also type பண்ணலாம்"
//                       />
//                     </td>
//                     <td>
//                       <input
//                         type="number"
//                         placeholder="0"
//                         value={row.rate}
//                         onChange={e => handleChange(row.id, 'rate', e.target.value)}
//                         min="0"
//                         step="0.01"
//                       />
//                     </td>
//                     <td className="total-cell">
//                       <input
//                         type="number"
//                         placeholder="0"
//                         value={row.total_rate}
//                         onChange={e => handleChange(row.id, 'total_rate', e.target.value)}
//                         min="0"
//                         step="0.01"
//                         style={{ color: '#e65100', fontWeight: '600' }}
//                       />
//                     </td>
//                     <td>
//                       <button
//                         className="btn btn-danger"
//                         onClick={() => deleteRow(row.id)}
//                         title="Delete in the Row"
//                       >
//                         🗑️
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* Add Row Button */}
//           <div style={{ marginTop: '15px' }}>
//             <button className="btn btn-success" onClick={addRow}>
//               ➕ Add Row
//             </button>
//           </div>

//           {/* Grand Total */}
//           <div className="totals-section">
//             <div className="totals-box">
//               <div className="totals-row">
//                 <span>Total Items:</span>
//                 <span>{rows.filter(r => r.total_rate).length}</span>
//               </div>
//               <div className="totals-row">
//                 <span>Grand Total:</span>
//                 <span>₹{grandTotal.toFixed(2)}</span>
//               </div>
//             </div>
//           </div>

//           {/* Action Buttons */}
//           <div className="btn-group">
//             <button className="btn btn-primary" onClick={handleNext}>
//               Next → Customer Details
//             </button>
//             <button className="btn btn-secondary" onClick={handleClear}>
//               🗑️ Clear All
//             </button>
//           </div>

//           <p style={{ 
//             marginTop: '10px', 
//             fontSize: '12px', 
//             color: '#888',
//             fontStyle: 'italic' 
//           }}>
            
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default HomePage;

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';

const newRow = () => ({
  id: Date.now() + Math.random(),
  description: '',
  length: '',
  height: '',
  sqft: '',
  rate: '',
  total_rate: ''
});

function HomePage() {
  const navigate = useNavigate();

  const [rows, setRows] = useState(() => {
    const saved = localStorage.getItem('invoice_rows');
    if (saved) { try { return JSON.parse(saved); } catch { return [newRow()]; } }
    return [newRow()];
  });

  useEffect(() => {
    localStorage.setItem('invoice_rows', JSON.stringify(rows));
  }, [rows]);

  const handleChange = (id, field, value) => {
    setRows(prev => prev.map(row => {
      if (row.id !== id) return row;
      const updated = { ...row, [field]: value };
      const len = parseFloat(field === 'length' ? value : updated.length) || 0;
      const hgt = parseFloat(field === 'height' ? value : updated.height) || 0;
      if (len > 0 && hgt > 0) updated.sqft = (len * hgt).toFixed(2);
      else if (field === 'length' || field === 'height') updated.sqft = '';
      const sqftVal = parseFloat(field === 'sqft' ? value : updated.sqft) || 0;
      const rateVal = parseFloat(field === 'rate' ? value : updated.rate) || 0;
      updated.total_rate = sqftVal > 0 && rateVal > 0 ? (sqftVal * rateVal).toFixed(2) : '';
      return updated;
    }));
  };

  const addRow = () => setRows(prev => [...prev, newRow()]);

  const deleteRow = (id) => {
    if (rows.length === 1) { alert('At least one row required!'); return; }
    setRows(prev => prev.filter(r => r.id !== id));
  };

  const grandTotal = rows.reduce((sum, r) => sum + (parseFloat(r.total_rate) || 0), 0);

  const handleNext = () => {
    if (!rows.some(r => r.description || r.total_rate)) {
      alert('Please add at least one item!'); return;
    }
    navigate('/checklist');
  };

  const handleClear = () => {
    if (window.confirm('Clear all data?')) {
      localStorage.removeItem('invoice_rows');
      localStorage.removeItem('invoice_checklist');
      localStorage.removeItem('invoice_notes');
      setRows([newRow()]);
    }
  };

  const th = { background: '#ff6b00', color: 'white', padding: '11px 8px', textAlign: 'center', fontWeight: '700', fontSize: '13px', whiteSpace: 'nowrap' };
  const td = { padding: '5px 6px', border: '1px solid #e0e0e0', textAlign: 'center', verticalAlign: 'middle' };
  const inp = { width: '100%', border: 'none', background: 'transparent', fontSize: '13px', padding: '4px', outline: 'none', textAlign: 'center' };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>

      {/* ── HEADER ── */}
      <div style={{ background: 'linear-gradient(135deg,#ff6b00,#ff8c00)', boxShadow: '0 2px 10px rgba(0,0,0,0.2)' }}>
        <div style={{ height: '5px', background: '#c43e00' }} />
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 24px', flexWrap: 'wrap', gap: '10px' }}>

          {/* Logo + Name */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
            <div style={{ background: 'white', borderRadius: '8px', padding: '5px', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
              <img src={logo} alt="Logo" style={{ height: '55px', width: '55px', objectFit: 'contain', display: 'block' }} onError={e => e.target.style.display = 'none'} />
            </div>
            <div>
              <div style={{ color: 'white', fontSize: '22px', fontWeight: '800', letterSpacing: '1px' }}>AKSHAYA</div>
              <div style={{ color: 'rgba(255,255,255,0.92)', fontSize: '13px' }}>Wood Furniture & Interiors</div>
              <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: '11px' }}>We Decore Your Dreams</div>
            </div>
          </div>

          {/* Right: contact + History button */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px' }}>
            <div style={{ textAlign: 'right', color: 'white', fontSize: '12px', lineHeight: '1.8' }}>
              <div style={{ fontWeight: '700' }}>GST: 33CGAPS5480A2ZN</div>
              <div>📞 Cell: 9965113567</div>
              <div style={{ fontSize: '11px', opacity: 0.9 }}>No 38/12, Digital Garden, Annanji, Theni - 625531</div>
            </div>
            {/* History Button */}
            <button onClick={() => navigate('/history')} style={{
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              border: '2px solid rgba(255,255,255,0.7)',
              borderRadius: '8px',
              padding: '7px 18px',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: '700',
              backdropFilter: 'blur(4px)',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              transition: 'all 0.2s'
            }}
              onMouseOver={e => e.currentTarget.style.background = 'rgba(255,255,255,0.35)'}
              onMouseOut={e => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
            >
              📋 Invoice History
            </button>
          </div>
        </div>
        <div style={{ height: '5px', background: '#c43e00' }} />
      </div>

      {/* ── MAIN ── */}
      <div style={{ maxWidth: '1150px', margin: '28px auto', padding: '0 18px' }}>
        <div style={{ background: 'white', borderRadius: '12px', padding: '24px', boxShadow: '0 2px 15px rgba(0,0,0,0.08)' }}>
          <div style={{ fontSize: '17px', fontWeight: '700', color: '#ff6b00', borderBottom: '2px solid #ff6b00', paddingBottom: '10px', marginBottom: '18px' }}>
            Invoice Items
          </div>

          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
              <thead>
                <tr>
                  <th style={{ ...th, width: '50px' }}>S.No</th>
                  <th style={{ ...th, minWidth: '200px' }}>Description</th>
                  <th style={{ ...th, width: '90px' }}>Length</th>
                  <th style={{ ...th, width: '90px' }}>Height</th>
                  <th style={{ ...th, width: '100px' }}>Sqft / Qty</th>
                  <th style={{ ...th, width: '100px' }}>Rate (₹)</th>
                  <th style={{ ...th, width: '120px' }}>Total Rate (₹)</th>
                  <th style={{ ...th, width: '70px' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, i) => (
                  <tr key={row.id} style={{ background: i % 2 === 0 ? '#fff' : '#fff8f3' }}>
                    <td style={{ ...td, fontWeight: '600' }}>{i + 1}</td>
                    <td style={{ ...td, textAlign: 'left' }}>
                      <input type="text" placeholder="Item name..." value={row.description}
                        onChange={e => handleChange(row.id, 'description', e.target.value)}
                        style={{ ...inp, textAlign: 'left' }} />
                    </td>
                    <td style={td}><input type="number" placeholder="0" value={row.length} onChange={e => handleChange(row.id, 'length', e.target.value)} min="0" step="0.01" style={inp} /></td>
                    <td style={td}><input type="number" placeholder="0" value={row.height} onChange={e => handleChange(row.id, 'height', e.target.value)} min="0" step="0.01" style={inp} /></td>
                    <td style={{ ...td, background: '#e8f5e9' }}>
                      <input type="number" placeholder="auto" value={row.sqft} onChange={e => handleChange(row.id, 'sqft', e.target.value)} min="0" step="0.01" style={{ ...inp, color: '#2e7d32', fontWeight: '600' }} />
                    </td>
                    <td style={td}><input type="number" placeholder="0" value={row.rate} onChange={e => handleChange(row.id, 'rate', e.target.value)} min="0" step="0.01" style={inp} /></td>
                    <td style={{ ...td, background: '#fff3e0' }}>
                      <input type="number" placeholder="0" value={row.total_rate} onChange={e => handleChange(row.id, 'total_rate', e.target.value)} min="0" step="0.01" style={{ ...inp, color: '#e65100', fontWeight: '600' }} />
                    </td>
                    <td style={td}>
                      <button onClick={() => deleteRow(row.id)} style={{ background: '#f44336', color: 'white', border: 'none', borderRadius: '6px', padding: '6px 12px', cursor: 'pointer', fontSize: '14px' }}>🗑</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{ marginTop: '14px' }}>
            <button onClick={addRow} style={{ background: '#4caf50', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 22px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}>
              + Add Row
            </button>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '18px' }}>
            <div style={{ background: '#fff8f3', border: '1px solid #ffccaa', borderRadius: '10px', padding: '14px 22px', minWidth: '270px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0', fontSize: '14px', borderBottom: '1px solid #ffe0cc' }}>
                <span>Total Items:</span><span>{rows.filter(r => r.total_rate).length}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '7px 0', fontSize: '16px', fontWeight: '700', color: '#ff6b00' }}>
                <span>Grand Total:</span><span>₹{grandTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span>
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '12px', marginTop: '18px', flexWrap: 'wrap' }}>
            <button onClick={handleNext} style={{ background: '#ff6b00', color: 'white', border: 'none', borderRadius: '8px', padding: '12px 28px', cursor: 'pointer', fontSize: '15px', fontWeight: '600', boxShadow: '0 3px 8px rgba(255,107,0,0.3)' }}>
              Next → Customer Details
            </button>
            <button onClick={handleClear} style={{ background: '#607d8b', color: 'white', border: 'none', borderRadius: '8px', padding: '12px 22px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}>
              Clear All
            </button>
            <button onClick={() => navigate('/history')} style={{ background: 'white', color: '#ff6b00', border: '2px solid #ff6b00', borderRadius: '8px', padding: '12px 22px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}>
              📋 View History
            </button>
          </div>

          <p style={{ marginTop: '10px', fontSize: '12px', color: '#aaa', fontStyle: 'italic' }}>
            Data auto-saved — remains safe even after page close or refresh
          </p>
        </div>
      </div>
    </div>
  );
}

export default HomePage;